import { NavLink, useNavigate } from "react-router-dom";
import logoICIAR from "../assets/img/ICIAR-LOGO.png";

export const NavBarPublic = () => {
    const navigate = useNavigate();

    const goLogin = () => navigate("/public/login");
        
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow-sm py-2">
            <div className="container">
                <NavLink className="navbar-brand d-flex align-items-center" to="/public/home">
                    <img src={logoICIAR} alt="Logo ICIAR" width={40} className="me-2 bg-white p-1" />
                    <span className="fw-bold fs-5 d-none d-sm-inline">ICIAR GTO</span>
                </NavLink>

                <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navPublic" aria-controls="navPublic" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navPublic">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 text-center">
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link px-3 ${isActive ? 'active fw-bold border-bottom border-primary' : ''}`} to="/public/home">
                                Inicio
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link px-3 ${isActive ? 'active fw-bold border-bottom border-primary' : ''}`} to="/public/aboutus">
                                Nosotros
                            </NavLink>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle px-3" href="#" id="dropInst" role="button" data-bs-toggle="dropdown">
                                Institutos
                            </a>
                            <ul className="dropdown-menu dropdown-menu-dark shadow-lg border-0 mt-2" aria-labelledby="dropInst">
                                <li><NavLink className="dropdown-item py-2" to="/public/institutes/saint_paul_theological_institute">Teológico San Pablo</NavLink></li>
                                <li><NavLink className="dropdown-item py-2" to="/public/institutes/ministerial_training_institute">Formación Ministerial</NavLink></li>
                                <li><NavLink className="dropdown-item py-2" to="/public/institutes/institute_for_pastoes_and_childrens_ministers">Pastores Infantiles</NavLink></li>
                                <li><hr className="dropdown-divider opacity-25" /></li>
                                <li><NavLink className="dropdown-item py-2" to="/public/institutes/music_insitute">Instituto de Música</NavLink></li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link px-3 ${isActive ? 'active fw-bold border-bottom border-primary' : ''}`} to="/public/advertisements">
                                Anuncios
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link px-3 ${isActive ? 'active fw-bold border-bottom border-primary' : ''}`} to="/public/blogs">
                                Blog
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link px-3 ${isActive ? 'active fw-bold border-bottom border-primary' : ''}`} to="/public/contact">
                                Contacto
                            </NavLink>
                        </li>
                    </ul>

                    <div className="d-grid d-lg-block mt-3 mt-lg-0">
                        <button type="button" className="btn btn-primary rounded-pill px-4 shadow-sm" onClick={goLogin}>
                            <i className="bi bi-person-circle me-2"></i>Ingresar
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};